import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FormControlLabel, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";
import { v4 as uuidv4 } from "uuid";
import { getSavedChats, saveSavedChats, ChatSummary } from "./chatStorage";
import {
  PageContainer,
  Title,
  ConnectionForm,
  SaveButton,
  CloseButton,
  FileInput,
  StyledTextField,
  RadioGroupStyled,
  RadioStyled
} from "./styled"; 

const NewConnection: React.FC = () => {
  const [connectionType, setConnectionType] = useState("custom");
  const [file, setFile] = useState<File | null>(null);
  const navigate = useNavigate();

  const handleFileUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files?.[0]) {
      setFile(e.target.files[0]);
    }
  };

  const handleSubmitSchema = async () => {
    if (!file) {
      alert("Please upload a valid schema file.");
      return;
    }
    const formData = new FormData();
    formData.append("file", file);

    try {
      const apiUrl = process.env.REACT_APP_API_URL as string;
      if (!apiUrl) {
        alert("API URL is not defined.");
        return;
      }

      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Failed to upload schema. Please try again.");
      }

      const newChatId = uuidv4();

      const existingChats = getSavedChats();
      const newChat: ChatSummary = {
        id: 0,  
        chatId: newChatId,
        title: "Chat after New Connection",
      };
            const updatedChats = [...existingChats, newChat];
      saveSavedChats(updatedChats);

      window.dispatchEvent(new Event("chatsUpdated"));

      navigate(`/chat?chatId=${newChatId}`);

      alert("Schema uploaded and imported successfully.");

    } catch (err) {
      const error = err as Error;  
      alert("Upload failed: " + error.message);
    }
  };

  return (
    <PageContainer>
      <CloseButton onClick={() => navigate(-1)}>
        <Close fontSize="large" />
      </CloseButton>

      <Title>New Connection</Title>
      <Typography variant="body1" sx={{ color: "#091a4f" }}>
        Add a new database connection
      </Typography>

      <ConnectionForm>
        <StyledTextField
          label="Name"
          variant="outlined"
          fullWidth
          disabled
          value="Postgres Prod"
          sx={{ mb: 2 }}
        />

        <FileInput type="file" accept=".sql" onChange={handleFileUpload} />

        <h3>Data Source Type</h3>
        <RadioGroupStyled
          value={connectionType}
          onChange={(e) => setConnectionType(e.target.value)}
        >
          <FormControlLabel value="sample" control={<RadioStyled />} label="Choose a sample dataset" />
          <FormControlLabel value="custom" control={<RadioStyled />} label="Setup a custom connection" />
        </RadioGroupStyled>

        <h3>Create a custom connection</h3>
        <RadioGroupStyled>
          <FormControlLabel value="postgres" control={<RadioStyled />} label="Postgres, MySQL, Snowflake, or MS SQL Server" />
          <FormControlLabel value="sqlite" control={<RadioStyled />} label="SQLite file" />
          <FormControlLabel value="csv" control={<RadioStyled />} label="CSV file" />
          <FormControlLabel value="excel" control={<RadioStyled />} label="Excel file" />
          <FormControlLabel value="sas" control={<RadioStyled />} label="SAS7BDAT file" />
        </RadioGroupStyled>

        <SaveButton variant="contained" onClick={handleSubmitSchema}>
          Upload Schema
        </SaveButton>
      </ConnectionForm>
    </PageContainer>
  );
};

export default NewConnection;
